<div class="modal-body modal-padding">
    <h5>{{title}}</h5>
    <p>{{message}}</p>
    <div class="button-wrapper">
      <button class="modal-button-style" (click)="backToDashboard(); ">Ok</button>
    </div>
  </div>